import Section from "../Section";
import QuickAdd from '../global/QuickAdd';

export default class SearchResults extends Section {

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.loadQuickAdd();
    this.removeAsterisks();
    this.clearSearch();

    this.theme.addBadges(this.element, 1000);

    this.searchInput = /** @type {HTMLInputElement} */ (element.querySelector('input[type="search"]'));
    this.searchInput.addEventListener('input', this.onSearchChange);

    this.searchClear = /** @type {HTMLElement} */ (element.querySelector('.search-drawer--clear'));
    this.searchClear.addEventListener('click', this.clearSearch);
    this.searchClear.addEventListener('keydown', this.tabClearSearch);
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }

  removeAsterisks = () => {
    var pageTitle = document.querySelector('.page--title');
    pageTitle.textContent = pageTitle.textContent.replace('*', '');

    var searchInput = /** @type {HTMLInputElement} */ (document.querySelector('.search-bar .input-group-field'));
    searchInput.value = searchInput.value.replace('*', '');

    var breadcrumbLast = document.querySelector('nav.breadcrumb span:last-child');
    if (breadcrumbLast) {
      breadcrumbLast.textContent = breadcrumbLast.textContent.replace('*', '');
    }
  }

  onSearchChange = (e) => {
    if (this.searchInput.value.length > 0) {
      this.searchClear.style.opacity = '1';
      this.searchClear.tabIndex = 0
    }
    else {
      this.searchClear.style.opacity = '0';
      this.searchClear.tabIndex = -1;
    }
  }

  clearSearch = (e) => {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.onSearchChange();
      this.searchInput.focus();
    }
  }

  tabClearSearch = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.searchInput.value = '';
      this.onSearchChange();
      this.searchInput.focus();
    }
  }
}
